import { render, staticRenderFns } from "./CreatePostulationOmil.vue?vue&type=template&id=71a2ed5a&scoped=true"
import script from "./CreatePostulationOmil.vue?vue&type=script&lang=ts"
export * from "./CreatePostulationOmil.vue?vue&type=script&lang=ts"
import style0 from "./CreatePostulationOmil.vue?vue&type=style&index=0&id=71a2ed5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a2ed5a",
  null
  
)

export default component.exports